import { GridConfigModel } from 'Models'

export const configGridBankEmployees: GridConfigModel = {
	columns: [
		{
			order: 1,
			slug: 'user',
			name: 'Сотрудник',
			width: '20%',
			custom: true,
		},
		{
			order: 2,
			slug: 'user_status',
			name: 'Статус',
			width: '20%',
			custom: true,
		},
		{
			order: 3,
			slug: 'roles_names',
			name: 'Роль',
			width: '30%',
		},
		{
			order: 4,
			slug: 'territorial_bank_name',
			name: 'Тербанк',
			width: '30%',
		},
		{
			order: 5,
			slug: 'edit',
			name: '',
			width: '150px',
			custom: true,
		},
	],
}

export enum USER_STATUS {
	ON_TIME_OFF = 'on_time_off',
	ACTIVE = 'active',
}
